<template>
  <v-card>
    <v-card-title class="d-flex align-center justify-space-between">
      <div>
        <v-icon left>mdi-table</v-icon>
        Comeback Offers Summary
      </div>
    </v-card-title>
    <v-card-text>
      <div v-if="loading" class="text-center py-8">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <div v-else>
        <v-table>
          <thead>
            <tr>
              <th>Metric</th>
              <th class="text-right">Count</th>
              <th class="text-right">Percentage</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>CB's Sent</td>
              <td class="text-right">{{ totals.entries }}</td>
              <td class="text-right">100%</td>
            </tr>
            <tr>
              <td>CB's Viewed (clicks > 0)</td>
              <td class="text-right">{{ totals.clicked }}</td>
              <td class="text-right">{{ pctClicked }}%</td>
            </tr>
            <tr>
              <td>Quotes from CB's</td>
              <td class="text-right">{{ totals.quotes }}</td>
              <td class="text-right">{{ pctQuotesOfEntries }}%</td>
            </tr>
            <tr>
              <td>Converted to Order</td>
              <td class="text-right">{{ totals.orders }}</td>
              <td class="text-right">{{ pctOrders }}%</td>
            </tr>
            <tr>
              <td>Conversion (Quotes from CB's / CB's Viewed)</td>
              <td class="text-right">—</td>
              <td class="text-right">{{ pctConversion }}%</td>
            </tr>
          </tbody>
        </v-table>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { statisticsService, importedOrderService } from "../services";

export default {
  name: "ComebackOffersTable",
  props: {
    startDate: { type: [String, Date], required: true },
    endDate: { type: [String, Date], required: true },
  },
  data() {
    return {
      loading: false,
      totals: {
        entries: 0,
        clicked: 0,
        quotes: 0,
        orders: 0,
      },
    };
  },
  computed: {
    pctClicked() {
      if (!this.totals.entries) return 0;
      return ((this.totals.clicked / this.totals.entries) * 100).toFixed(1);
    },
    pctQuotesOfEntries() {
      if (!this.totals.entries) return 0;
      return ((this.totals.quotes / this.totals.entries) * 100).toFixed(1);
    },
    pctOrders() {
      if (!this.totals.entries) return 0;
      return ((this.totals.orders / this.totals.entries) * 100).toFixed(1);
    },
    pctConversion() {
      if (!this.totals.clicked) return 0;
      return ((this.totals.quotes / this.totals.clicked) * 100).toFixed(1);
    },
    // Single key for both bounds so moving the range triggers one reload.
    rangeKey() {
      return `${this.toYmd(this.startDate)}|${this.toYmd(this.endDate)}`;
    },
  },
  watch: {
    rangeKey: { immediate: true, handler() { this.loadData(); } },
  },
  methods: {
    toYmd(d) {
      const dt = new Date(d);
      const y = dt.getFullYear();
      const m = String(dt.getMonth() + 1).padStart(2, '0');
      const day = String(dt.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    },
    async loadData() {
      this.loading = true;
      try {
        const startYmd = this.toYmd(this.startDate);
        const endYmd = this.toYmd(this.endDate);
        const response = await statisticsService.getComebackOfferStatistics({
          period: 'custom',
          startIso: startYmd,
          endIso: endYmd
        });
        const ordersResponse = await importedOrderService.list({
          page: 1,
          limit: 1,
          fromComeback: 'true',
          startDate: startYmd,
          endDate: endYmd,
        });
        if (response?.success) {
          const s = response.data.summary || {};
          this.totals.entries = Number(s.totalComebackOffers || 0);
          this.totals.clicked = Number(s.comebackOffersWithClicks || 0);
          this.totals.quotes = Number(s.quotesWithComebackOffers || 0);
        } else {
          this.totals = { entries: 0, clicked: 0, quotes: 0, orders: 0 };
        }
        this.totals.orders = ordersResponse?.total || 0;
      } catch (e) {
        console.error('Failed to load comeback offers summary', e);
        this.totals = { entries: 0, clicked: 0, quotes: 0, orders: 0 };
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.py-8 {
  padding-top: 32px;
  padding-bottom: 32px;
}
.text-right { text-align: right; }
</style>


